export default "__VITE_ASSET__B11owkBi__"